import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
    providedIn: 'root'
})
export class TransactionService {
    private _transactionId: string | null = null;
  
    constructor() {
     
    }

    public setTransactionId(transactionId: string) {
        this._transactionId = transactionId;
    }

    public getTransactionId(): string | null {
        return this._transactionId;
    }

    public clearTransactionId() {
        this._transactionId = null;
    }

    public startTransaction() {
        this._transactionId = uuidv4();
    }

    public endTransaction() {
        this._transactionId = null;
    }
}